module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      'zk-submenu': true,
      'is-active': _vm.active,
      'is-opened': _vm.opened
    }
  }, [_c('div', {
    ref: "submenu-title",
    staticClass: "zk-submenu__title"
  }, [_vm._t("title"), _vm._v(" "), _c('i', {
    class: {
      'zk-submenu__icon-arrow': true,
      'zk-icon-arrow-down': _vm.rootMenu.mode === 'vertical',
        'zk-icon-caret-bottom': _vm.rootMenu.mode === 'horizontal'
    }
  })], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.rootMenu.mode === 'horizontal' ? 'md-fade-bottom' : ''
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opened),
      expression: "opened"
    }],
    staticClass: "zk-menu"
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-61e05c0f"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/menu/src/submenu.vue
// module id = 260
// module chunks = 0